import React from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { l } from '@manychat/manyui'

import * as blockActions from 'common/builder/actions/blockActions'
import * as builderStateActions from 'common/builder/actions/builderStateActions'
import { createLinkedButton } from 'common/builder/actions/createLinkedButton'
import BlockButtonListComponent from 'common/builder/components/builder/BlockButtonList'
import { BlockType } from 'common/builder/constants/BlockType'
import { isAddButtonAllowed } from 'common/builder/models/Block/helpers'
import builderSelectors from 'common/builder/selectors/builder'
import * as entitySelectors from 'common/builder/selectors/builder/entitySelectors'
import { getIsAddButtonDisabledForIg } from 'common/builder/selectors/builder/nodeSelectors'

const BlockButtonListController = (props) => {
  const { builderId, blockId, hasCtaButton } = props

  const isAddButtonDisabledForIg = useAppSelector((state) =>
    getIsAddButtonDisabledForIg(state, builderId, blockId),
  )
  const disabledTooltipForIg = l.translate(
    'Buttons cannot be added before Quick Replies for the Instagram channel',
  )
  const disabledTooltipForWa = l.translate(
    'Only one Open Website button is available per one WhatsApp message. Remove other buttons from the message first.',
  )

  const { allowAdd, disabled, blockButtons } = useAppSelector((state) => {
    const block = entitySelectors.getBlockById(state, builderId, blockId)
    const blockButtons = entitySelectors
      .getButtons(state, builderId, blockId)
      .filter((b) => !b.isSmartLink)
    const { nodeType } = entitySelectors.getParentNode(state, builderId, blockId)
    const buttons = entitySelectors.getButtonsMap(state, builderId)
    const allowAdd =
      isAddButtonAllowed(block, nodeType, { buttons }) && block.type !== BlockType.MESSAGE_TEMPLATE

    const builder = builderSelectors.state.getById(state, builderId)

    let disabled = false

    if (builder.config.disableButton) {
      const root = builderSelectors.state.getRootNode(state, builderId)
      const qrBlock = builderSelectors.node.getQuickReplyBlock(state, builderId, root.id)
      disabled = Boolean(qrBlock.buttons.length)
    }

    return {
      allowAdd,
      disabled,
      blockButtons,
    }
  })

  const dispatch = useAppDispatch()
  const handleAdd = (initial) => {
    const btn = dispatch(createLinkedButton(builderId, blockId, initial))
    dispatch(builderStateActions.selectButton(builderId, btn.id))
  }
  const handleMoveButton = (dragButtonId, hoverButtonId) => {
    dispatch(blockActions.moveButton(builderId, blockId, dragButtonId, hoverButtonId))
  }
  const handleMoveFirstButton = (dragButtonId) => {
    dispatch(blockActions.moveFirstButton(builderId, blockId, dragButtonId))
  }
  const getTooltip = () => {
    if (isAddButtonDisabledForIg) {
      return disabledTooltipForIg
    }
    return hasCtaButton ? disabledTooltipForWa : null
  }
  return (
    <BlockButtonListComponent
      {...props}
      blockButtons={blockButtons}
      allowAdd={allowAdd}
      disabled={disabled || isAddButtonDisabledForIg || hasCtaButton}
      tooltip={getTooltip()}
      onAdd={handleAdd}
      onMoveButton={handleMoveButton}
      onMoveFirstButton={handleMoveFirstButton}
    />
  )
}

export default BlockButtonListController
